import { 
  EpDevPApiClient 
} from '../EpDevPApiClient';
import { 
  IEpDevPApiConfig, 
  IEpDevPConfigApiClient 
} from '../types/configApi';
import { 
  EpDevPConifgApiPathsFactory 
} from './EpDevPConifgApiFactories';


export class EpDevPConfigApiClient extends EpDevPApiClient implements IEpDevPConfigApiClient {

  public async getConfig(): Promise<IEpDevPApiConfig> {
    const epDevPApiConfig: IEpDevPApiConfig = await this.request({
      method: 'GET',
      url: await this.createUrl(EpDevPConifgApiPathsFactory.createGetPath())
    });    
    return epDevPApiConfig;
  }

}
